import React from "react";

function DoorEmergency() {
    return (
        <div>
            <h2>Emergency Procedures & First Aid Awareness</h2>
            <p>
                Door Supervisors must be prepared to respond quickly and effectively to emergencies. This module covers key procedures, first aid awareness, and coordination with emergency services.
            </p>

            <h3> Types of Emergencies</h3>
            <ul>
                <li>Fire or smoke detection</li>
                <li>Medical emergencies (e.g. unconsciousness, bleeding)</li>
                <li>Evacuation due to threat or hazard</li>
                <li>Violent or criminal incidents</li>
                <li>Structural or environmental hazards</li>
            </ul>

            <h3>Emergency Procedures</h3>
            <ul>
                <li>Raise the alarm and notify relevant personnel</li>
                <li>Follow the site’s emergency action plan (EAP)</li>
                <li>Assist with evacuation and crowd control</li>
                <li>Keep exits clear and guide people to safety</li>
                <li>Communicate clearly and remain calm</li>
            </ul>

            <h3>First Aid Awareness</h3>
            <ul>
                <li>Recognize signs of common medical emergencies</li>
                <li>Know how to place someone in the recovery position</li>
                <li>Provide reassurance and basic care until help arrives</li>
                <li>Call 999 and give accurate information</li>
                <li>Use on-site first aid kits or AEDs if trained</li>
            </ul>

            <h3>Working with Emergency Services</h3>
            <ul>
                <li>Provide clear, factual information</li>
                <li>Assist with access and crowd control</li>
                <li>Follow instructions from police, fire, or paramedics</li>
                <li>Document the incident afterward</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A fire alarm sounds during a busy event. What steps do you take to ensure a safe and orderly evacuation?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.hse.gov.uk/event-safety/emergencies.htm" target="_blank" rel="noreferrer">HSE – Emergency Planning</a></li>
                <li><a href="https://www.sja.org.uk/" target="_blank" rel="noreferrer">St John Ambulance – First Aid Advice</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Emergency Response</a></li>
            </ul>
        </div>
    );
}

export default DoorEmergency;
